import { render } from "./month-records.vue?vue&type=template&id=3c0992de"
import script from "./month-records.vue?vue&type=script&lang=js"
export * from "./month-records.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__